<template>
    <div>

        <Toast />
        
        <div class="listings-datasets__hero">
            <div class="listings-datasets__container">
                <div class="flex justify-between items-center py-10">
                    <div>
                        <h1 class="text-3xl font-bold text-gray-800 dark:text-white tracking-tight">Listings & Datasets</h1>
                        <p class="mt-2 text-gray-600 dark:text-gray-400">Manage and organize listings and datasets settings</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="listings-datasets__container pb-10">
            <!-- Tabs -->
            <div class="mb-6">
                <div class="border-b border-gray-200 dark:border-gray-700">
                    <nav class="-mb-px flex space-x-8">
                        <button
                            v-if="hasPermission('tags-manager')"
                            @click="activeTab = 'tags'"
                            :class="[
                                'py-4 px-1 border-b-2 font-medium text-sm',
                                activeTab === 'tags'
                                    ? 'border-echoes-primary text-echoes-primary'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                            ]"
                        >
                            Tags
                        </button>
                        <button
                            v-if="hasPermission('tags-manager')"
                            @click="activeTab = 'tag-types'"
                            :class="[
                                'py-4 px-1 border-b-2 font-medium text-sm',
                                activeTab === 'tag-types'
                                    ? 'border-echoes-primary text-echoes-primary'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                            ]"
                        >
                            Tag Types
                        </button>
                    </nav>
                </div>
            </div>
            
            <ListTags v-if="activeTab === 'tags'" />
            <ListTagTypes v-if="activeTab === 'tag-types'" />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import Toast from '@/components/toast.vue';
import ListTags from './ListTags.vue';
import ListTagTypes from './ListTagTypes.vue';
import { useStorage } from '@/composables/use-storage';

const { hasPermission } = useStorage();
const activeTab = ref('tags');
</script>
<style scoped lang="postcss">
.listings-datasets__hero {
    @apply relative mb-6 border-b border-echoes-border-gray bg-echoes-background-black;
}


.listings-datasets__container {
    @apply relative overflow-hidden w-full max-w-7xl p-5 ;
}
</style>